import type { FC } from "react";

import type { LayoutV2, Pages } from "~/core";
import { FooterV4 } from "~/features/footerV4/FooterV4";
import { useAction } from "~/widgets/use-action";

export const MainFooterV2: FC<{ data: LayoutV2 }> = ({ data }) => {
  const { callAction: onCallAction, isActionInactive } = useAction();

  const getUrl = (detailedPage: Pages): string => {
    if (!detailedPage?.slug) {
      return `/`;
    }

    const { segment, slug } = detailedPage;
    if (segment) {
      return `/${segment}/${slug}`;
    } else {
      return `/${slug}`;
    }
  };

  return (
    <FooterV4
      data={data}
      getUrl={getUrl}
      onCallAction={onCallAction}
      isControlInactive={isActionInactive}
      width="100%"
      m={{ mx: "auto", mt: "auto" }}
      maxWidth={1270}
      p={{ px: 15, py: 40 }}
    />
  );
};
